export const FILE_EXTENSIONS = {
  EXCEL: 'xlsx',
  PDF: 'pdf',
  DOCX: 'docx',
};
